var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYellowPattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 8,
    viewBox: "0 0 266 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_701_164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.15 0H0V2.83H22.15V0Z",
    fill: "#FEDA4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4498 0H44.2998V2.83H66.4498V0Z",
    fill: "#FEDA4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2999 4.25H22.1499V7.08H44.2999V4.25Z",
    fill: "#FEDA4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.61 4.25H66.46V7.08H88.61V4.25Z",
    fill: "#FEDA4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.76 0H88.6099V2.83H110.76V0Z",
    fill: "#FEDA4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.06 0H132.91V2.83H155.06V0Z",
    fill: "#FEDA4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.91 4.25H110.76V7.08H132.91V4.25Z",
    fill: "#FEDA4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.22 4.25H155.07V7.08H177.22V4.25Z",
    fill: "#FEDA4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.37 0H177.22V2.83H199.37V0Z",
    fill: "#FEDA4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.67 0H221.52V2.83H243.67V0Z",
    fill: "#FEDA4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.52 4.25H199.37V7.08H221.52V4.25Z",
    fill: "#FEDA4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.83 4.25H243.68V7.08H265.83V4.25Z",
    fill: "#FEDA4C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_701_164"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 265.83,
    height: 7.08,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowPattern);
export default __webpack_public_path__ + "static/media/yellow-pattern.7e2417b61ac983ba88b63366b538678b.svg";
export { ForwardRef as ReactComponent };